import GeneralTracker from '../GeneralTracker';


export default class RegistrationOverlayTracker extends GeneralTracker {
  CAPTURE_NAME = 'ui:registration:overlay:usage';
  STORAGE_KEY = 'trackingRegistrationOverlay';
  VERSION = '1';

  setHandlers() {
    const service = this.getService();
    service.on('openRegistrationOverlay', this.onOpen);
    service.on('closeRegistrationOverlay', this.onClose);
    service.on('submitRegistrationOverlay', this.onSubmit);
  }

  onOpen = (payload) => {
    const trackPayload = {
      action: 'open',
      tag: { ...payload },
    };

    this.track(trackPayload);
  };

  onClose = (payload) => {
    const trackPayload = {
      action: 'close',
      tag: { ...payload },
    };

    this.track(trackPayload);
  };

  onSubmit = ({ email, ...data }) => {
    const emailDomain = email.split('@')[1] || '';

    this.track({
      action: 'submit',
      tag: { ...data, emailDomain },
    });
  };
}
